import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import vr from '../../../../utils/Verifiers';
import { get, set } from 'lodash';
import { dateFormatConDia } from '../../../../utils/DateFunctions';

const ConteosCampo = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [semanas, setsemanas] = useState({ trasplante: [], corte: [], semana_actual: '', 'dia': "" });
    const tiposConteo = ['plantas', 'tallos'];
    const [selecciones, setselecciones] = useState({ semana: '', tipo_conteo: 'plantas', reporte: 'pendientes', semanas: 0 });
    const [conteos, setconteos] = useState([]);
    const [tipo_visualizacion, settipo_visualizacion] = useState('ajustar');
    const [perdidasForm, setperdidasForm] = useState({});
    const [showDetalles, setshowDetalles] = useState(null);
    const [ranchosValvulas, setranchosValvulas] = useState({ ranchos: [{ value: '-', name: "Todos los ranchos" }], valvulas: { '-': [] } });


    useEffect(() => {
        getConteos(selecciones.tipo_conteo, selecciones.semanas, '-', '-', setloader);
    }, []);

    const getConteos = async (tipo_conteo = selecciones.tipo_conteo, semanas = selecciones.semanas, rancho, valvula, loadAnimation = false) => {
        setselecciones({ ...selecciones, tipo_conteo, semanas, rancho, valvula });
        const resp = await vr.getDataAPI('campo/v2/conteos/get', { tipo_conteo, semanas, rancho, valvula }, loadAnimation, setdialog);
        if (!resp.estatus) return;
        setranchosValvulas({ ranchos: resp.ranchos ?? [{ value: '-', name: "Todos los ranchos" }], valvulas: resp.valvulas ?? { "-": [] } });
        setconteos(resp.data ?? []);
        const smn = resp.semanas ?? { trasplante: [], corte: [], semana_actual: "", dia: "" };
        smn.rancho = rancho;
        smn.valvula = valvula;
        setsemanas(smn);
    }

    const getConteosRevision = async (s_trasplante, s_corte, rancho, valvula, loadAnimation = false) => {
        setsemanas({ ...semanas, semana_trasplante: s_trasplante, semana_corte: s_corte, rancho, valvula });
        const resp = await vr.getDataAPI('campo/v2/conteos/revision/get', { semana_trasplante: s_trasplante, semana_corte: s_corte, rancho, valvula }, loadAnimation, setdialog);
        if (!resp.estatus) return;
        setranchosValvulas({ ranchos: resp.ranchos ?? [{ value: '-', name: "Todos los ranchos" }], valvulas: resp.valvulas ?? { "-": [] } });
        setconteos(resp.data ?? []);
        const smn = resp.semanas ?? { trasplante: [], corte: [], semana_actual: "", dia: "" };
        setsemanas({ ...semanas, ...smn, semana_trasplante: s_trasplante, semana_corte: s_corte, rancho, valvula });
    }

    const updateConteo = async (index, valor) => {
        const sendData = {
            inventario_campo_id: conteos[index].inventario_campo_id,
            semanas: selecciones.semanas,
            tipo_conteo: selecciones.tipo_conteo,
            valor: valor,
            rancho: semanas.rancho,
            valvula: semanas.valvula
        }
        const original = JSON.parse(JSON.stringify(conteos[index]));

        let nuevos = [...conteos];
        const tipo = selecciones.tipo_conteo === 'plantas' ? "pc_total" : "tc_total"
        nuevos[index][tipo] = valor;
        setconteos(nuevos);
        const resp = await vr.getDataAPI('campo/v2/conteos/update', sendData, false, setdialog);
        if (!resp.estatus) {
            nuevos[index] = original;
            setconteos(nuevos);
            return;
        }
        setconteos(resp.data ?? []);
        //const resp = await vr.getDataAPI('campo/v2/conteos/update', { inventario_campo_id, tipo_conteo, valor }, false, setdialog);
    }

    const agregarPerdida = async (perdida, conteo_id) => {
        perdida = vr.numberFormat(perdida, 0);
        setperdidasForm({ ...perdidasForm, [conteo_id]: perdida });
        if (perdida < 0) {
            return;
        }
        const payload = { conteo_id, perdida, semanas: selecciones.semanas, tipo_conteo: selecciones.tipo_conteo, rancho: semanas.rancho, valvula: semanas.valvula };
        const resp = await vr.getDataAPI('campo/v2/conteos/perdidas/add', payload, false, setdialog);
        if (!resp.estatus) {
            return;
        }
        setconteos(resp.data ?? []);
    }

    const eliminarPerdida = async (perdida_id) => {
        const payload = { perdida_id, semanas: selecciones.semanas, tipo_conteo: selecciones.tipo_conteo, rancho: semanas.rancho, valvula: semanas.valvula };
        const resp = await vr.getDataAPI('campo/v2/conteos/perdidas/delete', payload, setloader, setdialog);
        if (!resp.estatus) {
            return;
        }
        setconteos(resp.data ?? []);
    }

    return (
        <>
            <div className='vw-100 p-0 ps-2 pe-2 overflow bg-white dosis' style={{ height: "calc( 100vh - 60px)" }}>
                <div className='w-100 round-left-xxl gradient-small-black text-white p-1 ps-3 text-xl'>
                    Conteos de campo <span className='text-s ms-3 text-300'>{semanas.semana_actual}/{semanas.dia}</span>
                </div>
                <div className='w-100 bg-white4 blur-xxl m-0 p-2' style={{ position: "sticky", top: 0, left: 0, zIndex: 9 }}>
                    <div className='row justify-content-around w-100 m-0 p-0'>
                        {tipo_visualizacion === 'ajustar' && <>
                            <div className='form-group bw-200'>
                                <label className='text-bold'>Semanas{selecciones.tipo_conteo === 'plantas' ? ' desde trasplante' : ' antes de corte'}</label>
                                <input type='number'
                                    value={selecciones.semanas}
                                    onChange={(e) => getConteos(selecciones.tipo_conteo, vr.numberFormat(e.target.value, 0), "-", "-")}
                                    className='form-control text-bold border round-xs shadow-sm'
                                />
                            </div>
                            <div className="bw m-0 p-1" style={{ '--bw': '200px' }}>
                                <label className='text-bold'>Tipo de conteo</label>
                                <select className='form-control text-bold border round-xs shadow-sm'
                                    value={selecciones.tipo_conteo}
                                    onChange={(e) => {
                                        getConteos(e.target.value, selecciones.semanas, "-", "-", false);
                                    }} >
                                    {tiposConteo?.map((tc, i) =>
                                        <option key={i + "tc"} value={tc}>{tc.toUpperCase()}</option>
                                    )}
                                </select>
                            </div>

                            <div className='form-group bw-200'>
                                <label className='text-bold'>Rancho</label>
                                <select className='form-control' value={get(semanas, 'rancho')} onChange={(e) =>
                                    getConteos(selecciones.tipo_conteo, selecciones.semanas, e.target.value, "-", false)} >
                                    {ranchosValvulas.ranchos?.map((s, i) =>
                                        <option key={i + "ran"} value={s.value}>{s.name}</option>
                                    )}
                                </select>
                            </div>

                            <div className='form-group bw-200'>
                                <label className='text-bold'>Valvula</label>
                                <select className='form-control' value={get(semanas, 'valvula')}
                                    disabled={['-', null, undefined].includes(semanas.rancho)}
                                    onChange={(e) =>
                                        getConteos(selecciones.tipo_conteo, selecciones.semanas, semanas.rancho, e.target.value, false)} >
                                    {(['-', null, undefined].includes(semanas.rancho) ? [] : ranchosValvulas.valvulas[semanas.rancho])?.map((s, i) =>
                                        <option key={i + "valv"} value={s.value}>{s.name}</option>
                                    )}
                                </select>
                            </div>
                        </>}

                        {tipo_visualizacion === 'revisar' && <>
                            <div className='form-group bw-200'>
                                <label className='text-bold'>Semana de trasplante</label>
                                <select className='form-control' value={get(semanas, 'semana_trasplante')} onChange={(e) => getConteosRevision(e.target.value, semanas?.semana_corte, "-", "-", false)} >
                                    <option value='' >Seleccione una</option>
                                    {semanas.trasplante?.map((s, i) =>
                                        <option key={i + "st"} value={s}>{s}</option>
                                    )}
                                </select>
                            </div>
                            <div className='form-group bw-200'>
                                <label className='text-bold'>Semana de corte</label>
                                <select className='form-control' value={get(semanas, 'semana_corte')} onChange={(e) => getConteosRevision(semanas?.semana_trasplante ?? null, e.target.value, "-", "-", false)} >
                                    <option value='' >Seleccione una</option>
                                    {semanas.corte?.map((s, i) =>
                                        <option key={i + "sc"} value={s}>{s}</option>
                                    )}
                                </select>
                            </div>
                            <div className='form-group bw-200'>
                                <label className='text-bold'>Rancho</label>
                                <select className='form-control' value={get(semanas, 'rancho')} onChange={(e) =>
                                    getConteosRevision(semanas?.semana_trasplante ?? null, semanas?.semana_corte, e.target.value, "-", false)} >
                                    {ranchosValvulas.ranchos?.map((s, i) =>
                                        <option key={i + "ran"} value={s.value}>{s.name}</option>
                                    )}
                                </select>
                            </div>
                            <div className='form-group bw-200'>
                                <label className='text-bold'>Valvula</label>
                                <select className='form-control' value={get(semanas, 'valvula')}
                                    disabled={['-', null, undefined].includes(semanas.rancho)}
                                    onChange={(e) =>
                                        getConteosRevision(semanas?.semana_trasplante ?? null, semanas?.semana_corte, semanas.rancho, e.target.value, false)} >
                                    {(['-', null, undefined].includes(semanas.rancho) ? [] : ranchosValvulas.valvulas[semanas.rancho])?.map((s, i) =>
                                        <option key={i + "valv"} value={s.value}>{s.name}</option>
                                    )}
                                </select>
                            </div>
                        </>}
                        <div className="bw text-center" style={{ '--bw': '200px' }}>
                            <label className='text-300 w-100 text-start ps-2'>Modo actual:<span className='text-bold upper ms-2'>{tipo_visualizacion}</span></label>
                            <button className='btn btn-warning btn-sm text-bold shadow-sm  w-100 round-xs'
                                onClick={() => {
                                    if (tipo_visualizacion === 'revisar') {
                                        getConteos(selecciones.tipo_conteo, selecciones.semanas, setloader);
                                    } else {
                                        setsemanas({ ...semanas, semana_trasplante: '', semana_corte: '' });
                                        setconteos([]);
                                    }
                                    settipo_visualizacion(tipo_visualizacion === 'ajustar' ? 'revisar' : 'ajustar')
                                }}
                            >{tipo_visualizacion === 'ajustar' ? 'Cambiar a modo revisión' : 'Cambiar a modo ajuste'}</button>
                        </div>
                    </div>
                </div>

                <div className='row justify-content-around w-100 m-0 p-0 ps-1 pe-1'>


                    {!loader && (conteos ?? []).length === 0 && semanas.semana_actual !== '' && tipo_visualizacion === 'ajustar' &&
                        <div className="w text-center text-300 mt-5 h5" style={{ '--w': '100%' }}>Sin registros para mostrar</div>}
                    {!loader && (conteos ?? []).length === 0 && semanas.semana_actual !== '' && tipo_visualizacion === 'revisar' && (semanas.semana_trasplante || semanas.semana_corte) &&
                        <div className="w text-center text-300 mt-5 h5" style={{ '--w': '100%' }}>No se encontraron registros que coincidan con las semanas de trasplante = {semanas.semana_trasplante} y semana de corte = {semanas.semana_corte} seleccionadas</div>}
                    {!loader && (conteos ?? []).length === 0 && semanas.semana_actual !== '' && tipo_visualizacion === 'revisar' && !semanas.semana_trasplante && !semanas.semana_corte &&
                        <div className="w text-center text-300 mt-5 h5" style={{ '--w': '100%' }}>Selecccione una semana de trasplante y/o de corte. Si realiza la seleccion de ambas semanas solo se mostraran los registros que coincidan con ambas selecciones simultaneamente</div>}
                    <div className="w m-0 p-0 mt-2 border-bottom" style={{ '--w': '95%' }}></div>
                    {!loader && (conteos ?? []).length > 0 &&
                        <div className="bw m-0 p-1 pt-0" style={{ '--bw': '1600px', overflow: "auto" }}>
                            <table className='table table-sm table-striped'>
                                <thead>
                                    <tr>
                                        <th scope='col' className='text-start'>Bloque</th>
                                        <th scope='col' className='text-start'>Rancho</th>
                                        <th scope='col' className='text-start'>Valvula</th>
                                        <th scope='col' className='text-start'>Plant. plan</th>
                                        <th scope='col' className='text-start'>Semanas programa</th>
                                        <th scope='col' className='text-start'>Semanas conteos</th>
                                        <th scope='col' className='text-start' style={{ maxWidth: "80px" }}>Plant. vivas</th>
                                        <th scope='col' className='text-start' style={{ maxWidth: "110px" }}>Perdidas</th>
                                        <th scope='col' className='text-center' style={{ maxWidth: "80px" }}>C. Plantas</th>
                                        <th scope='col' className='text-center' style={{ maxWidth: "80px" }}>C. Tallos</th>
                                        <th scope='col' className='text-center'>Rancho</th>
                                        <th scope='col' className='text-center'>Valvula</th>
                                        <th scope='col' className='text-end ps-2 pe-2'>Cama inicio</th>
                                        <th scope='col' className='text-end ps-2 pe-2'>Cama fin</th>
                                        <th scope='col' className='text-end ps-2 pe-2'>Total metros</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(conteos ?? []).map((c, i) => <React.Fragment key={i + "frag"}>
                                        <tr className='nowrap border-bottom' >
                                            <td className='text-bold text-start align-middle'>{c.bloque}</td>
                                            <td className='text-start align-middle'>{c.rancho_nombre}</td>
                                            <td className='text-start align-middle'>{c.valvula_codigo}</td>
                                            <td className='text-start align-middle'>{c.plantas_inventario}</td>
                                            <td className='text-s text-start align-middle p-0'>
                                                <div className='row justify-content-start w-100 m-0 p-0'>
                                                    <div className="w" style={{ '--w': '100%' }}><span className='me-2' style={{ fontStyle: 'italic' }}>Trasplante:</span>{c.semana_trasplante} - {c.dia_trasplante}</div>
                                                    <div className="w border-top pb-2" style={{ '--w': '100%' }}><span className='me-2' style={{ fontStyle: 'italic' }}>Corte:</span>{c.semana_cosecha} - {c.dia_cosecha}</div>
                                                </div>
                                            </td>
                                            <td className='text-s text-start align-middle p-0 ps-2 pe-2'>
                                                <div className='row justify-content-start w-100 m-0 p-0'>
                                                    <div className="w pb-0" style={{ '--w': '100%' }}>
                                                        <span className='me-2 text-300' style={{ fontStyle: 'italic' }}>Plantas:</span>
                                                        <span className='' >{c.pc_semana ?? "---"}{c.pc_dia ? ` - ${c.pc_dia}` : ''}</span>
                                                    </div>
                                                    <div className="w border-top pb-2" style={{ '--w': '100%' }}>
                                                        <span className='me-2' style={{ fontStyle: 'italic' }}>Tallos:</span>
                                                        <span className='' >{c.tc_semana ?? '---'}{c.tc_dia ? ` - ${c.tc_dia}` : ''}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='text-start align-middle'>{Math.round(c.plantas_inventario - c.pc_total - (c?.perdidas?.total ?? 0))}</td>
                                            <td className='text-center p-0 align-middle' style={{ maxWidth: "110px" }}>
                                                <div className={`row d-flex m-0 p-0 justify-content-evenly align-items-center w-100`} style={{ width: "30px" }}>
                                                    <input
                                                        style={{ maxWidth: "70px" }}
                                                        type='number'
                                                        className='form-control form-control-sm p-0 m-0 text-center lh1'
                                                        value={(perdidasForm[`${c.id}`] ?? 0)}
                                                        onChange={(e) => agregarPerdida(e.target.value, c.id)}
                                                    />
                                                    {c.perdidas?.total > 0 && <i className={`fa fa-eye${showDetalles === c.id ? '' : '-slash opacity-70'} pointer`} style={{ maxWidth: "30px", "transition": "all 0.5s ease" }} onClick={() => setshowDetalles(showDetalles === c.id ? null : c.id)}></i>}
                                                    {c.perdidas?.total <= 0 && <i className={`fa fa-eye-slash opacity-20`} style={{ maxWidth: "30px", "transition": "all 0.5s ease" }}></i>}


                                                </div>

                                            </td>
                                            <td className='text-center p-0 align-middle ps-2 pe-2' style={{ maxWidth: "80px" }}>
                                                {(selecciones.tipo_conteo !== "plantas" || tipo_visualizacion === 'revisar') && <>{c.pc_total}</>}
                                                {selecciones.tipo_conteo == "plantas" && tipo_visualizacion !== 'revisar' &&
                                                    <input
                                                        type='number'
                                                        className='form-control form-control-sm p-0 m-0 text-center lh1'
                                                        value={c.pc_total}
                                                        onChange={(e) => {
                                                            const val = Math.max(vr.numberFormat(e.target.value, 0), 0);
                                                            updateConteo(i, val);
                                                        }}
                                                    />}
                                            </td>
                                            <td className='text-center p-0 align-middle' style={{ maxWidth: "80px" }}>
                                                {(selecciones.tipo_conteo !== "tallos" || tipo_visualizacion === 'revisar') && <>{c.tc_total}</>}
                                                {selecciones.tipo_conteo == "tallos" && tipo_visualizacion !== 'revisar' &&
                                                    <input
                                                        type='number'
                                                        className='form-control form-control-sm p-0 m-0 text-center lh1'
                                                        value={c.tc_total}
                                                        onChange={(e) => {
                                                            const val = Math.max(vr.numberFormat(e.target.value, 0), 0);
                                                            updateConteo(i, val);
                                                        }}
                                                    />}
                                            </td>

                                            <td className='text-center align-middle'>{c.camas_info.rancho}</td>
                                            <td className='text-center align-middle'>{c.camas_info.valvula}</td>
                                            <td className='text-end ps-2 pe-2 align-middle'>{c.camas_info.inicio}</td>
                                            <td className='text-end ps-2 pe-2 align-middle'>{c.camas_info.fin}</td>
                                            <td className='text-end ps-2 pe-2 align-middle'>{c.camas_info.metros_utilizados}</td>
                                        </tr>
                                        {showDetalles === c.id && c.perdidas?.total > 0 && <tr className='border-bottom'>
                                            <td colSpan={13} className='text-s text-start p-0'>
                                                <div className="w m-0 p-2 pb-4 pt-1 bg-white border-bottom border-warning" style={{ '--w': '100%' }}>
                                                    <div className='d-flex row m-0 p-0 w-100 justify-content-center'>
                                                        <div className='bw-1000 mb-2 p-0 ps-3 h5 text-red3'>
                                                            Registro de perdidas asociadas
                                                        </div>
                                                        <div className="w" style={{ '--w': '100%' }}></div>
                                                        <div className="bw" style={{ '--bw': '1000px' }}>
                                                            <table className='table table-sm'>
                                                                <thead>
                                                                    <tr>
                                                                        <th scope='col'>Fecha de registro</th>
                                                                        <th scope='col'>Usuario</th>
                                                                        <th scope='col'>Perdida</th>
                                                                        <th scope='col' className='text-center' style={{ width: "70px" }}>Borrar</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(c?.perdidas?.registros ?? []).map((p, j) =>
                                                                        <tr key={j + "perdida"}>
                                                                            <td className='align-middle'>{dateFormatConDia(p.fecha, "ND")}</td>
                                                                            <td className='align-middle'>{p.usuario_nombre}</td>
                                                                            <td className='align-middle text-bold'>{p.perdida}<span className='text-xs text-300 ms-2 text-dark'>plantas</span></td>
                                                                            <td className='text-center' style={{ width: "70px" }}>
                                                                                <button className='btn btn-danger btn-sm p-0 w-100' onClick={() => eliminarPerdida(p.id)}>
                                                                                    Borrar
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    <tr className='border-none'>
                                                                        <td className='align-middle text-end pe-2 text-bold opacity-60 text-m border-none' colSpan={2}>Perdida total:</td>
                                                                        <td className='align-middle text-bold text-red3 text-m border-none'>{(c?.perdidas?.registros ?? []).reduce((acc, p) => acc + p.perdida, 0)}<span className='text-xs text-300 ms-2 text-dark'>plantas</span></td>

                                                                        <td className='text-center border-none' style={{ width: "70px" }}></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </td>
                                        </tr>}
                                    </React.Fragment>

                                    )}
                                </tbody>
                            </table>
                        </div>
                    }

                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader ? ldr : null}
        </>
    )
}

export default ConteosCampo;